// extracted by mini-css-extract-plugin
module.exports = {"background":"layout-module--background--1nVU8","fullWidth":"layout-module--fullWidth--2SyQu","layout":"layout-module--layout--1Co2r"};